module.exports = __webpack_public_path__ + "static/img/banner_5.cc47ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_5.png
// module id = y1QA
// module chunks = 1